import React, { Component } from "react";
import { loading } from "../components/CustomComponent.js";

// นโยบายความเป็นส่วนตัวของเว็บ CMMS (BPS) + แอปช่าง S-Vibe BPS (iOS/Android)
// หน้านี้เป็น Privacy Policy URL ที่กรอกใน App Store Connect / Google Play (https://bpsservices.m-vibe.com/policy-privacy) - ต้องเปิดได้โดยไม่ล็อกอิน
// เนื้อหาเรื่องข้อมูลที่เก็บต้องตรงกับที่แอปทำจริง (app.json ของ CMMS-Mobile) และกับแบบฟอร์ม App Privacy / Data safety
// ถ้าแอปเริ่มเก็บข้อมูลประเภทใหม่ (เช่นเพิ่ม push notification หรือ analytics) ต้องแก้ทั้งหน้านี้และแบบฟอร์มในทั้งสอง store
const LAST_UPDATED = { TH: "27 ตุลาคม 2569", EN: "October 27, 2026" };
const CONTACT_EMAIL = "mvibeservice@gmail.com";

const CONTENT = {
  TH: {
    title: "นโยบายความเป็นส่วนตัว",
    subtitle: "สำหรับระบบ CMMS (เว็บไซต์) และแอปพลิเคชัน S-Vibe BPS",
    updated: "ปรับปรุงล่าสุด",
    sections: [
      {
        heading: "1. ผู้ควบคุมข้อมูลส่วนบุคคล",
        body: [
          "บริษัท เอ็ม ไวบ์ เทค จำกัด (\"บริษัท\" หรือ \"เรา\") เป็นผู้ให้บริการระบบ CMMS สำหรับงานซ่อมบำรุง ซึ่งประกอบด้วยเว็บไซต์สำหรับผู้ดูแลระบบ คลังสินค้า และลูกค้า และแอปพลิเคชัน S-Vibe BPS สำหรับช่างเทคนิค (รวมเรียกว่า \"บริการ\")",
          "นโยบายนี้อธิบายว่าเราเก็บ ใช้ เปิดเผย และดูแลข้อมูลส่วนบุคคลของคุณอย่างไร ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA)",
        ],
      },
      {
        heading: "2. ผู้ใช้บริการ",
        body: [
          "บริการนี้ใช้ภายในองค์กรที่เป็นลูกค้าของเรา บัญชีผู้ใช้สร้างโดยผู้ดูแลระบบขององค์กร ไม่เปิดให้บุคคลทั่วไปสมัครใช้งานเอง และไม่ได้มีไว้สำหรับเด็ก",
        ],
      },
      {
        heading: "3. ข้อมูลที่เราเก็บ",
        list: [
          ["ข้อมูลบัญชี", "ชื่อ-นามสกุล รหัสพนักงาน อีเมล เบอร์โทรศัพท์ บทบาทและสิทธิ์ในระบบ องค์กรที่สังกัด และรหัสผ่าน (เก็บแบบเข้ารหัสทางเดียว ไม่มีใครอ่านรหัสผ่านจริงได้)"],
          ["ข้อมูลการทำงาน", "ใบแจ้งซ่อม ใบสั่งงาน เวลาเช็คอิน-เช็คเอาท์ ผลการตรวจ PM และค่าที่วัดได้ รายการอะไหล่ที่เบิกและใช้ สต๊อกอะไหล่บนรถ เลขไมล์ และรายงานบริการ"],
          ["ตำแหน่งที่ตั้ง (แอป S-Vibe BPS)", "ตำแหน่งที่แม่นยำตอนเช็คอินหน้างาน เพื่อยืนยันว่าอยู่ที่หน้างานจริง และตำแหน่งระหว่างเดินทางขณะที่มีงานค้างอยู่ เพื่อบันทึกเส้นทางและระยะทาง แอปอาจอ่านตำแหน่งขณะทำงานอยู่เบื้องหลังเฉพาะช่วงที่มีงานค้าง และหยุดบันทึกเมื่อปิดงาน แอปไม่ติดตามตำแหน่งเมื่อไม่มีงาน"],
          ["รูปภาพและลายเซ็น", "รูปถ่ายหน้างานที่คุณถ่ายหรือเลือกจากคลังภาพเพื่อแนบในใบงาน และลายเซ็นกับชื่อของลูกค้าผู้รับบริการ"],
          ["ข้อมูลลูกค้าผู้รับบริการ", "ชื่อ ที่อยู่ ข้อมูลติดต่อ และข้อมูลทรัพย์สินหรืออุปกรณ์ของลูกค้าที่ปรากฏในใบงาน ซึ่งองค์กรของคุณเป็นผู้บันทึก"],
          ["ข้อมูลอุปกรณ์", "รุ่นอุปกรณ์ ระบบปฏิบัติการ เวอร์ชันแอป และภาษา"],
          ["ข้อมูลการใช้งานระบบ", "บันทึกการเปลี่ยนแปลงข้อมูล (audit log) เช่น ผู้แก้ไขและเวลาแก้ไข และบันทึกการเรียกใช้ระบบที่จำเป็นต่อความปลอดภัยและการแก้ปัญหา"],
        ],
        after: [
          "เมื่อสัญญาณอินเทอร์เน็ตขาด แอปจะเก็บข้อมูลงานที่คุณบันทึกไว้ในเครื่องชั่วคราว และส่งขึ้นระบบอัตโนมัติเมื่อกลับมาออนไลน์ จากนั้นจะลบออกจากคิวในเครื่อง",
        ],
      },
      {
        heading: "4. สิทธิ์การเข้าถึงอุปกรณ์ที่แอปขอ",
        list: [
          ["กล้อง", "สแกน QR Code ของอุปกรณ์และถ่ายรูปหน้างาน"],
          ["คลังรูปภาพ", "เลือกรูปมาแนบในใบงาน"],
          ["ตำแหน่งที่ตั้ง", "เช็คอินหน้างานและบันทึกเส้นทางตามข้อ 3"],
          ["ไมโครโฟนและการรู้จำเสียง", "แปลงเสียงพูดเป็นข้อความแทนการพิมพ์ เสียงจะถูกประมวลผลโดยบริการรู้จำเสียงของระบบปฏิบัติการ (Apple หรือ Google) เราเก็บเฉพาะข้อความที่ได้ ไม่เก็บไฟล์เสียง"],
        ],
        after: ["คุณปิดสิทธิ์เหล่านี้ได้ทุกเมื่อในการตั้งค่าของเครื่อง แต่บางฟังก์ชันอาจใช้งานไม่ได้"],
      },
      {
        heading: "5. วัตถุประสงค์และฐานทางกฎหมาย",
        list: [
          ["ให้บริการตามสัญญา", "ยืนยันตัวตน มอบหมายและบันทึกงานซ่อมบำรุง เบิกและตัดอะไหล่ และออกรายงานบริการและเอกสารที่เกี่ยวข้อง"],
          ["ประโยชน์โดยชอบด้วยกฎหมาย", "ยืนยันการเข้าหน้างาน คำนวณระยะเดินทาง ดูแลความปลอดภัยของระบบ และป้องกันการใช้งานโดยมิชอบ"],
          ["หน้าที่ตามกฎหมาย", "เก็บเอกสารทางบัญชีและภาษีตามที่กฎหมายกำหนด"],
        ],
        after: ["เราไม่ขายข้อมูลส่วนบุคคล ไม่ใช้ข้อมูลเพื่อโฆษณา และไม่ติดตามคุณข้ามแอปหรือเว็บไซต์ของผู้อื่น"],
      },
      {
        heading: "6. การเปิดเผยข้อมูล",
        body: ["เราเปิดเผยข้อมูลเท่าที่จำเป็นต่อการให้บริการเท่านั้น ได้แก่"],
        list: [
          ["องค์กรของคุณ", "ผู้ดูแลระบบและผู้มีสิทธิ์ในองค์กรที่คุณสังกัดเห็นข้อมูลงานของคุณ ข้อมูลของแต่ละองค์กรแยกจากกัน"],
          ["ผู้ให้บริการโครงสร้างพื้นฐาน", "ผู้ให้บริการคลาวด์ที่เก็บเซิร์ฟเวอร์และฐานข้อมูล"],
          ["ระบบขององค์กรลูกค้า", "ระบบ ERP/บัญชีขององค์กรของคุณ (เช่น Q-ERP หรือ SAP) เพื่อเบิกอะไหล่ ตัดสต๊อก และออกเอกสาร ตามที่องค์กรของคุณกำหนด"],
          ["หน่วยงานรัฐ", "เมื่อกฎหมายกำหนดหรือมีคำสั่งโดยชอบด้วยกฎหมาย"],
        ],
      },
      {
        heading: "7. ระยะเวลาเก็บรักษา",
        body: [
          "เราเก็บข้อมูลตลอดระยะเวลาที่บัญชีของคุณยังใช้งานอยู่และตามสัญญาให้บริการกับองค์กรของคุณ เอกสารทางบัญชีและภาษีเก็บตามระยะเวลาที่กฎหมายกำหนด เมื่อพ้นระยะเวลาแล้วเราจะลบหรือทำให้ข้อมูลไม่สามารถระบุตัวบุคคลได้",
        ],
      },
      {
        heading: "8. ความปลอดภัยของข้อมูล",
        body: [
          "ข้อมูลรับส่งผ่านการเชื่อมต่อที่เข้ารหัส (HTTPS) รหัสผ่านเก็บแบบเข้ารหัสทางเดียว ข้อมูลเข้าสู่ระบบในเครื่องเก็บในพื้นที่ปลอดภัยของระบบปฏิบัติการ การเข้าถึงข้อมูลจำกัดตามบทบาทและสิทธิ์ของผู้ใช้ และมีบันทึกการแก้ไขข้อมูลเพื่อตรวจสอบย้อนหลังได้",
        ],
      },
      {
        heading: "9. สิทธิของเจ้าของข้อมูล",
        body: [
          "คุณมีสิทธิ์ขอเข้าถึงหรือขอสำเนาข้อมูล ขอแก้ไขให้ถูกต้อง ขอลบหรือระงับการใช้ข้อมูล คัดค้านการประมวลผล ขอโอนย้ายข้อมูล ถอนความยินยอม (ในกรณีที่ใช้ความยินยอม) และร้องเรียนต่อสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล",
          "ขอใช้สิทธิ์หรือขอลบบัญชีได้ที่ผู้ดูแลระบบขององค์กรคุณ หรือติดต่อเราทางอีเมลด้านล่าง เราจะตอบกลับภายใน 30 วัน",
        ],
      },
      {
        heading: "10. การเปลี่ยนแปลงนโยบาย",
        body: [
          "เราอาจปรับปรุงนโยบายนี้เป็นครั้งคราว และจะแสดงวันที่ปรับปรุงล่าสุดไว้ด้านบนของหน้านี้ หากเปลี่ยนแปลงในสาระสำคัญ เราจะแจ้งผ่านบริการหรือผ่านองค์กรของคุณ",
        ],
      },
      {
        heading: "11. ติดต่อเรา",
        contact: ["บริษัท เอ็ม ไวบ์ เทค จำกัด", "อีเมล: "],
      },
    ],
  },
  EN: {
    title: "Privacy Policy",
    subtitle: "For the CMMS system (website) and the S-Vibe BPS app",
    updated: "Last updated",
    sections: [
      {
        heading: "1. Data Controller",
        body: [
          "M VIBE TECH CO., LTD. (\"the Company\", \"we\" or \"us\") operates the CMMS maintenance system, which consists of the website for administrators, warehouse staff and customers, and the S-Vibe BPS app for field technicians (together, the \"Service\").",
          "This policy explains how we collect, use, disclose and protect your personal data in accordance with Thailand's Personal Data Protection Act B.E. 2562 (2019) (PDPA).",
        ],
      },
      {
        heading: "2. Who Uses the Service",
        body: [
          "The Service is used internally by organizations that are our customers. User accounts are created by each organization's administrator. The public cannot sign up, and the Service is not intended for children.",
        ],
      },
      {
        heading: "3. Data We Collect",
        list: [
          ["Account data", "Full name, employee ID, email, phone number, role and permissions, organization, and password (stored as a one-way hash so no one can read the original password)."],
          ["Work data", "Work requests, work orders, check-in and check-out times, PM inspection results and measurements, parts requested and used, parts stock carried in vehicles, mileage, and service reports."],
          ["Location (S-Vibe BPS app)", "Precise location when you check in at a job site, to confirm that you are on site, and location while traveling during an open job, to record your route and distance. The app may read location in the background only while a job is open and stops recording when the job is closed. The app does not track location when you have no open job."],
          ["Photos and signatures", "Job-site photos that you take or pick from your photo library to attach to work orders, and the signature and name of the customer receiving the service."],
          ["Customer data", "Names, addresses, contact details and asset or equipment information of service customers that appear on work orders, as entered by your organization."],
          ["Device data", "Device model, operating system, app version and language."],
          ["System usage data", "Records of data changes (audit log), such as who made a change and when, and request logs needed for security and troubleshooting."],
        ],
        after: [
          "When there is no internet connection, the app temporarily keeps the work you record on the device and sends it automatically when you are back online, then removes it from the queue on the device.",
        ],
      },
      {
        heading: "4. Device Permissions Used by the App",
        list: [
          ["Camera", "Scan equipment QR codes and take job-site photos."],
          ["Photo library", "Attach photos to work orders."],
          ["Location", "Check in at job sites and record routes as described in section 3."],
          ["Microphone and speech recognition", "Convert speech to text instead of typing. Audio is processed by the operating system's speech recognition service (Apple or Google). We keep only the resulting text, not the audio."],
        ],
        after: ["You can turn off these permissions at any time in your device settings, but some features may stop working."],
      },
      {
        heading: "5. Purposes and Legal Bases",
        list: [
          ["Performance of a contract", "Authenticating users, assigning and recording maintenance work, requesting and issuing parts, and issuing service reports and related documents."],
          ["Legitimate interests", "Verifying site visits, calculating travel distance, securing the system and preventing misuse."],
          ["Legal obligations", "Keeping accounting and tax records as required by law."],
        ],
        after: ["We do not sell personal data, do not use it for advertising, and do not track you across other companies' apps or websites."],
      },
      {
        heading: "6. Disclosure of Data",
        body: ["We disclose data only as needed to provide the Service, to:"],
        list: [
          ["Your organization", "Administrators and authorized users in your organization can see your work data. Each organization's data is kept separate."],
          ["Infrastructure providers", "Cloud providers that host our servers and databases."],
          ["Your organization's systems", "Your organization's ERP or accounting system (such as Q-ERP or SAP), to request parts, update stock and issue documents, as configured by your organization."],
          ["Government authorities", "When required by law or a lawful order."],
        ],
      },
      {
        heading: "7. Data Retention",
        body: [
          "We keep data for as long as your account is active and as required by our service agreement with your organization. Accounting and tax records are kept for the period required by law. After that, we delete the data or make it no longer identify you.",
        ],
      },
      {
        heading: "8. Data Security",
        body: [
          "Data is transmitted over encrypted connections (HTTPS), passwords are stored as one-way hashes, sign-in data on the device is kept in the operating system's secure storage, access is limited by user role and permission, and changes to data are logged for auditing.",
        ],
      },
      {
        heading: "9. Your Rights",
        body: [
          "You have the right to access or obtain a copy of your data, correct it, request deletion or restriction, object to processing, request data portability, withdraw consent (where processing is based on consent), and lodge a complaint with Thailand's Personal Data Protection Committee.",
          "To exercise these rights or to request account deletion, contact your organization's administrator or email us at the address below. We will respond within 30 days.",
        ],
      },
      {
        heading: "10. Changes to This Policy",
        body: [
          "We may update this policy from time to time and will show the date of the latest update at the top of this page. If we make material changes, we will notify you through the Service or through your organization.",
        ],
      },
      {
        heading: "11. Contact Us",
        contact: ["M VIBE TECH CO., LTD.", "Email: "],
      },
    ],
  },
};

export default class PolicyPrivacy extends Component {
  constructor(props) {
    super(props);
    this.state = { lang: localStorage.getItem("lang") === "EN" ? "EN" : "TH" };
  }

  async componentDidMount() { loading(false); }

  renderSection = (section) => (
    <div key={section.heading} className="mb-4">
      <h5 className="fw-bold">{section.heading}</h5>
      {(section.body || []).map((text, i) => <p key={i}>{text}</p>)}
      {section.list && (
        <ul>
          {section.list.map(([label, text]) => (
            <li key={label} className="mb-2"><b>{label}</b> — {text}</li>
          ))}
        </ul>
      )}
      {(section.after || []).map((text, i) => <p key={i}>{text}</p>)}
      {section.contact && (
        <p className="mb-0">
          {section.contact[0]}<br />
          {section.contact[1]}<a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </p>
      )}
    </div>
  );

  render() {
    const { lang } = this.state;
    const content = CONTENT[lang];
    return (
      <div className="w-100 min-vh-100">
        <div className="row">
          <div className="col-11 col-sm-10 col-md-8 col-xl-6 py-4 mx-auto">
            <div className="d-flex justify-content-between align-items-start gap-3">
              <div>
                <h3 className="fw-bold mb-0">{content.title}</h3>
                <div className="text-secondary">{content.subtitle}</div>
                <div className="mb-3 text-secondary small">{content.updated}: {LAST_UPDATED[lang]}</div>
              </div>
              <div className="btn-group flex-shrink-0">
                {["TH", "EN"].map((code) => (
                  <button
                    key={code}
                    type="button"
                    className={`btn btn-sm ${lang === code ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => this.setState({ lang: code })}
                  >
                    {code}
                  </button>
                ))}
              </div>
            </div>
            <div className="rounded-4 bg-white p-3" lang={lang.toLowerCase()}>
              {content.sections.map(this.renderSection)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
